module.exports = __webpack_public_path__ + "static/media/img@2x.33686922.png";